import { gql } from 'apollo-angular';
import {
  PROJECT_DASHBOARD_FETCH_FRAGMENT
} from "../../deals/deals-committee-dashboard/graphql/getCommitteeDashboardProject";

export const CONTACT_PROJECT_FRAGMENT = gql`
    fragment ContactProjectsFields on Project {
      id
      name
      properties {
        name
        total_units
        total_lihtc_units
        entity {
          id
          entityAddresses {
            address {
              zipCode {
                city
                state {
                  abbreviation
                }
                county {
                  id
                  name
                }
              }
            }
          }
        }
      }
      projectType {
        name
      }
      projectStatuses{
        status {
          name
        }
        statusSequence{
          name
        }
        active
      }
      projectAttributes {
        attribute {
          name
          attributeType {
            name
          }
        }
      }
      projectDetail {
        risk_rating
        price_per_credit
        lt_equity_amount
        lower_tier_yield
        leverage
      }
      ltmodels(active: true){
        active_model
        kpiset {
          kpiset_detail {
            lower_tier_yield
          }
        }
      }
      pipelineProjects(
        hasPipeline: { column: NAME, operator: EQ, value: "Closing" }
      ) {
        closingDate: pipelineProjectDates(
          where: {
            AND: [
              { column: INITIAL_TARGET, value: false }
              {
                HAS: {
                  relation: "pipelineMilestone"
                  condition: {
                    AND: [
                      {
                        HAS: {
                          relation: "milestone"
                          condition: { column: "name", value: "Closed" }
                        }
                      }
                      {
                        HAS: {
                          relation: "pipeline"
                          condition: { column: "name", value: "Closing" }
                        }
                      }
                    ]
                  }
                }
              }
            ]
          }
        ) {
          id
          date
        }
        pipelineProjectDates(where: { column: INITIAL_TARGET, value: false }) {
          id
          pipelineMilestone {
            milestone {
              id
              name
            }
          }
          date
        }
      }
      projectCredits {
        amount
        price
        equity_amount
        crea_syndicated
        taxCreditType {
          name
          level
        }
        taxCreditDesignation {
          name
        }
        projectCreditOutlets {
          id
          fund {
            id
            name
          }
        }
      }
    }
`
export const CONTACT_COUNTS_FRAGMENT = gql`
    fragment ContactCountsFields on ParticipantProjectCounts {
      count
      units
      lihtc_units
      total_lt_equity
      avg_hard_debt
      avg_ppc
      avg_lt_yield
    }
`
export const CONTACT_DEAL_TOTALS_FRAGMENT = gql`
  fragment ContactTotalsFields on ParticipantProjectTotals{
    risk_ratings {
      risk_rating_a
      risk_rating_b
      risk_rating_c
      risk_rating_d
      risk_rating_f
    }
    closing {
      ...ContactCountsFields
    }
    closed {
      ...ContactCountsFields
    }
  }
  ${CONTACT_COUNTS_FRAGMENT}
`
export const get_people_contacts = gql`
  query getPeople($name:String, $page: Int) {
    getPeople(startsWithIndex: $name, page: $page) {
      data {
        id
        name
        employees {
          title
          organization {
            name
            id
          }
        }
        entity {
          id
          organization {
            name
          }
          emailAddresses {
            emailaddress
            id
          }
          phoneNumbers {
            area_code
            phone_number
          }
          entity_types {
            type {
              name
              tagType {
                name
              }
            }
          }
        }
      }
      paginatorInfo {
        currentPage
        total
        lastPage
        perPage
      }
    }
  }
`

export const get_orgs_contacts = gql`
    query getOrganizations($name: String, $page: Int!) {
      getOrganizations(startsWithIndex: $name, page: $page) {
        data {
          id
          name
          entity {
            id
            entityAddresses {
              name
              address {
                zipCode {
                  state {
                    abbreviation
                  }
                }
              }
            }
            webAddresses {
              protocol
              domain
              parameters
              subdomain
              tld
              path
            }
            phoneNumbers {
              phone_number
              area_code
            }
            entity_types {
              type {
                name
              }
            }
          }
        }
        paginatorInfo {
          currentPage
          total
          lastPage
          perPage
        }
      }
    }
`

export const get_sponsors = gql`
    query getSponsors($name: String!, $page: Int!) {
      getSponsors(startsWithIndex: $name, page: $page) {
        data {
          id
          name
        }
        paginatorInfo {
          currentPage
          total
          lastPage
          perPage
        }
      }
    }
`

export const get_person = gql`
  query person($id: ID!, $page: Int!){
    person(id: $id){
      id
      name
      employees {
        id
        title
        organization {
          id
          name
        }
      }
      entity {
        id
        organization {
          name
        }
        entityAddresses {
          name
          address {
            address1
            address2
            zipCode {
              zipcode
              city
              state {
                abbreviation
              }
            }
          }
        }
        entityEmailAddresses {
          name
          emailAddress {
            emailaddress
          }
        }
        entityPhoneNumbers {
          name
          phoneNumber {
            area_code
            phone_number
          }
        }
        phoneNumbers {
          area_code
          phone_number
        }
        entity_types {
          type {
            name
            tagType {
              name
            }
          }
        }
      }
    }
    projects: person_participant(person_id: $id, first:70, page: $page, exclude_dead: true){
      data {
        id
        role {
          id
          name
        }
        roleString
        project {
          ...ContactProjectsFields
        }
      }
      paginatorInfo{
        currentPage
        total
        lastPage
        perPage
      }
    }
    totals: participant_project_totals(person_id: $id, exclude_dead: true){
      ...ContactTotalsFields
    }
    deadTotals: participant_project_totals(person_id: $id, exclude_dead: false, project_status_name: "Dead"){
      ...ContactTotalsFields
    }
    deadDeals: person_participant(person_id: $id, first: 70, page: $page, exclude_dead: false, project_status_name: "Dead"){
      data {
        id
        roleString
        role {
          id
          name
        }
        project {
          ...ContactProjectsFields
        }
      }
      paginatorInfo{
        currentPage
        total
        lastPage
        perPage
      }
    }
    outlets: person_fund_participants(person_id: $id){
      id
      role {
        id
        name
      }
      fund {
        id
        name
      }
      certificatedOutlet {
        id
        organization {
          id
          name
        }
      }
    }
    company_event_attendees_by_person(person_id: $id){
      companyEvent {
        id
        title
        companyEventDates {
          start_date
          end_date
          start_time
          end_time
          timezone
        }
      }
      is_registered
    }
  }
  ${CONTACT_PROJECT_FRAGMENT}
  ${CONTACT_DEAL_TOTALS_FRAGMENT}
`
export const get_organization = gql`
    query organization($id: ID!, $page: Int!) {
      organization(id: $id){
        name
        ownershipInterests {
          id
          ownedEntity {
            fund {
              id
              name
              fundType {
                name
              }
            }
          }
          fundInvestor {
            id
            is_new
            is_repeat
          }
          ownershipInterestDetail {
            id
            investmentClass {
              name
            }
            amount
            admission_date
            exit_date
          }
        }
        sponsor {
          id
          name
          originatorRelationship {
            is_originated
            person {
              id
              name
            }
          }
        }
        employees {
          id
          title
          person {
            id
            name
            entity {
              entityEmailAddresses {
                name
                emailAddress {
                  emailaddress
                }
              }
              entityPhoneNumbers {
                name
                phoneNumber {
                  area_code
                  phone_number
                }
              }
              entityWebAddresses {
                name
                webAddress {
                  path
                  domain
                  subdomain
                  protocol
                  parameters
                  tld
                }
              }
            }
          }
        }
        entity {
          entityEmailAddresses {
            name
            emailAddress {
              emailaddress
            }
          }
          entityAddresses {
            name
            address {
              address1
              address2
              zipCode {
                zipcode
                city
                state {
                  abbreviation
                }
              }
            }
          }
          entityPhoneNumbers {
            name
            phoneNumber {
              area_code
              phone_number
            }
          }
          entityWebAddresses {
            name
            webAddress {
              path
              domain
              subdomain
              protocol
              parameters
              tld
            }
          }
          entity_types {
            id
            type {
              name
            }
          }
        }
      }
      org_participant(organization_id: $id, first: 70, page: $page, exclude_dead: true){
        data {
          id
          fund {
            name
            id
          }
          project {
              ...ContactProjectsFields
          }
          role {
            name
          }
          roleString
        }
        paginatorInfo {
          currentPage
          total
          lastPage
          perPage
        }
      }
      totals: participant_project_totals(organization_id: $id, exclude_dead: true){
        ...ContactTotalsFields
      }
      deadTotals: participant_project_totals(organization_id: $id, exclude_dead: false, project_status_name: "Dead"){
        ...ContactTotalsFields
      }
      deadDeals: org_participant(organization_id: $id, first: 70, page: $page, exclude_dead: false, project_status_name: "Dead"){
        data {
          id
          fund {
            name
            id
          }
          project {
            ...ContactProjectsFields
          }
          role {
            name
          }
          roleString
        }
        paginatorInfo {
          currentPage
          total
          lastPage
          perPage
        }
      }
    }
    ${CONTACT_PROJECT_FRAGMENT}
    ${CONTACT_DEAL_TOTALS_FRAGMENT}
`

export const get_sponsor = gql`
    query sponsor($id: ID!, $page: Int!){
      sponsor(id: $id){
        name
        nickname
        is_repeat
        originatorRelationship {
          is_originated
          organization {
            name
            id
          }
          person {
            name
            id
          }
        }
      }
      sponsor_orgs(sponsor_id: $id){
        name
        id
        ownershipInterests{
          id
          ownedEntity {
            fund {
              id
              name
              fundType {
                name
              }
            }
          }
          fundInvestor {
            id
            is_new
            is_repeat
          }
          ownershipInterestDetail {
            id
            investmentClass {
              name
            }
            amount
            admission_date
            exit_date
          }
        }
      }
      sponsor_participant(sponsor_id: $id, exclude_dead: true,  first: 70, page: $page){
        data {
          id
          roleString
          role {
            name
          }
          project {
            ...ContactProjectsFields
          }
        }
        paginatorInfo{
          currentPage
          total
          lastPage
          perPage
        }
      }
      deadDeals: sponsor_participant(sponsor_id: $id, exclude_dead: false, first: 70, page: $page, project_status_name: "Dead"){
        data {
          id
          role {
            name
          }
          roleString
          project {
            ...ContactProjectsFields
          }
        }
        paginatorInfo{
          currentPage
          total
          lastPage
          perPage
        }
      }
      sponsor_org_funds(sponsor_id: $id){
        id
      }
      totals: participant_project_totals(sponsor_id: $id, exclude_dead: true){
        ...ContactTotalsFields
      }
      deadTotals: participant_project_totals(sponsor_id: $id, exclude_dead: false, project_status_name: "Dead"){
        ...ContactTotalsFields
      }
    }
    ${CONTACT_PROJECT_FRAGMENT}
    ${CONTACT_DEAL_TOTALS_FRAGMENT}
`

export const get_sponsor_organization_deals = gql`
    query sponsorOrgDeals($id: ID!, $page: Int!){
      sponsor_org_participants(sponsor_id: $id, first: 50, page: $page, exclude_dead: true){
        data {
          ...ContactProjectsFields
          participants {
            role {
              name
            }
            organization {
              name
              id
              sponsor {
                id
                name
              }
            }
          }
        }
        paginatorInfo{
          currentPage
          total
          lastPage
          perPage
        }
      }
      deadSponsorDeals: sponsor_org_participants(sponsor_id: $id, first: 50, page: $page, exclude_dead: false, project_status_name: "Dead"){
        data {
          ...ContactProjectsFields
          participants {
            role {
              name
            }
            organization {
              name
              id
              sponsor {
                id
                name
              }
            }
          }
        }
        paginatorInfo{
          currentPage
          total
          lastPage
          perPage
        }
      }
      totals: participant_sponsor_project_totals(sponsor_id: $id, exclude_dead: true){
        ...ContactTotalsFields
      }
      deadTotals: participant_sponsor_project_totals(sponsor_id: $id, exclude_dead: false, project_status_name: "Dead"){
        ...ContactTotalsFields
      }
    }
    ${CONTACT_PROJECT_FRAGMENT}
    ${CONTACT_DEAL_TOTALS_FRAGMENT}
`
